<template>
  <component :is="layout">
    <template v-for="name in slotNames" :key="name" #[name]>
      <slot :name />
    </template>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import CondensedProductDetailPageLayout from '~/scopes/product-core/components/containers/layouts/ContainerProductDetailPageLayout/components/CondensedProductDetailPageLayout/CondensedProductDetailPageLayout.vue'
import ProductDetailPageLayout from '~/scopes/product-core/components/containers/layouts/ContainerProductDetailPageLayout/components/ProductDetailPageLayout/ProductDetailPageLayout.vue'
import { useCondensedFunnelExperiment } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/composables/useCondensedFunnelExperiment/useCondensedFunnelExperiment'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

import type { ContainerProductDetailPageLayoutSlots } from './ContainerProductDetailPageLayout.types'

const slots = defineSlots<ContainerProductDetailPageLayoutSlots>()

const slotNames = Object.keys(
  slots,
) as (keyof ContainerProductDetailPageLayoutSlots)[]

// The layout container maintains the shared in-scope flag (passing the
// category source), so readers (LargePicker, StepLayout, the funnel
// container) never trigger a product fetch — avoiding a wasted 404 on
// non-PDP pages where LargePicker is also used (gift-cards, buyback swap).
const { data: product } = useFetchProduct()

const isCondensedFunnelEnabled = useCondensedFunnelExperiment(
  () => product.value?.tracking.categoryId,
)

const layout = computed(() =>
  isCondensedFunnelEnabled.value
    ? CondensedProductDetailPageLayout
    : ProductDetailPageLayout,
)
</script>
